export default __webpack_public_path__ + "static/media/business-400.d6351dfa.png";